import {action, observable} from "mobx";
import {IEmailDto} from "../models/email";
import {NoticeTypeEnum} from "../models/notice";
import BaseStore from "./base/base-store";
import RootStore from "./root-store";

export default class EmailStore extends BaseStore {

    @observable
    public isSending: boolean = false;

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    public async sendEmail(request: IEmailDto) {
        try {
            this.startSending();
            const rootStore = this.rootStore;
            const result = await rootStore.emailApi.sendEmail(request);

            if (result.data.valid) {
                this.notify(NoticeTypeEnum.Success, rootStore.translationStore.translate("contact.sending-successful", "E-mail sent"));
            } else {
                Object.values(result.data.errors).map((error) => {
                    this.notify(NoticeTypeEnum.Failure, error);
                });
            }
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishSending();
        }
    }

    @action
    private startSending() {
        this.isSending = true;
    }

    @action
    private finishSending() {
        this.isSending = false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/email-store.ts